import React from "react";

const DateInput = ({ label, value, onChange }) => (
  <div className="flex flex-col">
    <label className="text-[11px] text-gray-500 mb-1">{label}</label>
    <div className="relative">
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="border rounded-md px-2.5 pr-8 h-8 text-xs w-full"
      />
      {/* 값이 없을 때 '-' 표시 (항상 수직 중앙 정렬) */}
      {!value && (
        <span className="pointer-events-none absolute right-8 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></span>
      )}
    </div>
  </div>
);

const BusinessFilters = ({
  businessName, setBusinessName,
  businessNumber, setBusinessNumber,
  status, setStatus,
  createdDate, setCreatedDate,   // 등록 일자
  reviewedDate, setReviewedDate, // 확인 일자
  onSearch, onReset,
  total
}) => {
  return (
    <>
      {/* 더 컴팩트한 그리드 폭으로 조정 */}
      <form
        onSubmit={onSearch}
        className="grid grid-cols-1 md:[grid-template-columns:minmax(140px,1fr)_200px_140px_160px_160px_auto] gap-2.5 mb-3"
      >
        <div className="flex flex-col">
          <label className="text-[11px] text-gray-500 mb-1">사업주</label>
          <input
            type="text"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            className="border rounded-md px-2.5 h-8 text-xs"
          />
        </div>

        <div className="flex flex-col">
          <label className="text-[11px] text-gray-500 mb-1">사업자 등록번호</label>
          <input
            type="text"
            inputMode="numeric"
            value={businessNumber}
            onChange={(e) => setBusinessNumber(e.target.value.replace(/[^0-9]/g, ""))}
            className="border rounded-md px-2.5 h-8 text-xs"
          />
        </div>

        <div className="flex flex-col">
          <label className="text-[11px] text-gray-500 mb-1">제출 상태</label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="border rounded-md px-2.5 h-8 text-xs"
          >
            <option value="">전체</option>
            <option value="pending">대기</option>
            <option value="approved">승인</option>
            <option value="rejected">반려</option>
          </select>
        </div>

        <DateInput label="등록 일자" value={createdDate} onChange={setCreatedDate} />
        <DateInput label="확인 일자" value={reviewedDate} onChange={setReviewedDate} />

        <div className="flex items-end gap-1.5">
          <button
            type="submit"
            className="px-3 py-1.5 rounded-md bg-[#7864F9] text-white text-xs font-semibold"
          >
            검색
          </button>
          <button
            type="button"
            onClick={onReset}
            className="px-3 py-1.5 rounded-md border text-xs font-semibold"
          >
            초기화
          </button>
        </div>
      </form>

      <div className="flex items-center justify-between mb-1.5">
        <div className="text-xs text-gray-600">총 <b>{total}</b>건</div>
        {/* 페이지 크기 선택 제거 (10 고정) */}
      </div>
    </>
  );
};

export default BusinessFilters;
